import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { AuthService } from "@ponder-core/auth/auth.service";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";

@Component({
    imports: [SvgIconComponent, NgClass],
    templateUrl: "./upgrade.component.html"
})
export class UpgradeAccountComponent {
    public readonly chevronIcon = SvgIcon.ChevronRight;
    public readonly questionIcon = SvgIcon.Support;

    public showDistinctCardTip: boolean = false;
    public showDistinctPlusCardTip: boolean = false;
    public showAvatarTip: boolean = false;
    public isMobile: boolean = false;

    public isAuthed: boolean = false;
    public isUserPlus: boolean = false;

    public constructor(private events: EventBroker, private authService: AuthService) {

    }

    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.isMobile = isMobileScreen();
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();

        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession) {
                this.isAuthed = true;

                this.authService.getRoleAndPermissions().then((roles?: RoleAndPermissions) => {
                    if (roles && roles.hasElevatedRole()) {
                        this.isUserPlus = true;
                    }
                });
            }
        });
    }

    public toggleDistinctCardTip(visibility: boolean): void {
        this.showDistinctCardTip = visibility;
        this.showDistinctPlusCardTip = false;
        this.showAvatarTip = false;
    }

    public toggleDistinctPlusCardTip(visibility: boolean): void {
        this.showDistinctPlusCardTip = visibility;
        this.showDistinctCardTip = false;
        this.showAvatarTip = false;
    }

    public toggleAvatarTip(visibility: boolean): void {
        this.showAvatarTip = visibility;
        this.showDistinctCardTip = false;
        this.showDistinctPlusCardTip = false;
    }
}